import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const ArrowLeftRightIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M15.293 12.293C15.6835 11.9024 16.3165 11.9024 16.707 12.293L19.707 15.293C20.0975 15.6835 20.0975 16.3165 19.707 16.707L16.707 19.707C16.3165 20.0975 15.6835 20.0975 15.293 19.707C14.9025 19.3165 14.9025 18.6835 15.293 18.293L16.5859 17H5C4.44777 17 4.00008 16.5522 4 16C4 15.4477 4.44772 15 5 15H16.5859L15.293 13.707C14.9025 13.3165 14.9025 12.6835 15.293 12.293ZM7.29297 4.29297C7.68349 3.90244 8.31651 3.90244 8.70703 4.29297C9.09748 4.6835 9.09753 5.31653 8.70703 5.70703L7.41406 7H19C19.5523 7 20 7.44772 20 8C19.9999 8.55222 19.5522 9 19 9H7.41406L8.70703 10.293C9.09748 10.6835 9.09753 11.3165 8.70703 11.707C8.31653 12.0975 7.68347 12.0975 7.29297 11.707L4.29297 8.70703C3.90247 8.31653 3.90252 7.6835 4.29297 7.29297L7.29297 4.29297Z'
        fill={color}
      />
    </svg>
  )
})
